<script setup>
import BaseModal from "../global/modals/BaseModal.vue";
import TwoFactorCodeField from "./TwoFactorCodeField.vue";
import {ref} from "vue";

const emit = defineEmits(['close', 'confirm']);

defineProps({
  errors: {
    required: false,
    type: Array,
    default: () => ([]),
  },
  loading: {
    required: false,
    type: Boolean,
    default: false,
  },
});

const code = ref('');

const handleConfirm = () => {
  if (code.value.length === 0) {
    return;
  }

  emit('confirm', code.value);
}
</script>

<template>
  <Teleport to="body">
    <BaseModal
      id="regenerate-codes-modal"
      @close="emit('close')"
    >
      <template #heading>
        Regenerate recovery codes?
      </template>

      <div>
        <p class="text-center">
          Your current recovery codes will stop working.<br>
          You will need to store the new codes in a secure password manager.<br>
          Enter your authentication code to confirm.
        </p>

        <TwoFactorCodeField
          v-model="code"
          :errors="errors"
          @submit="handleConfirm"
        />
      </div>

      <template #footer>
        <div class="w-100 d-flex justify-content-center m-0 m-auto">
          <button
            class="btn btn-danger btn-lg button font-weight-bold mx-3 mb-0 w-50"
            :disabled="loading"
            @click="emit('close')"
          >
            Cancel
          </button>
          <button
            class="btn btn-success btn-lg button font-weight-bold mx-3 mb-0 w-100"
            :class="{disabled: code.length === 0 || loading}"
            :disabled="code.length === 0 || loading"
            @click="handleConfirm"
          >
            Regenerate Recovery Codes
          </button>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<style>
  #regenerate-codes-modal .modal_window {
    max-width: 900px;
    min-width: 675px;
  }

  #regenerate-codes-modal .btn-danger {
    background: #F34F4F;
  }
</style>
